import queryString from 'query-string';
import { CommissionInvoiceFilter } from 'src/adminPanel/entities/offsetting/commissionInvoice/CommissionInvoiceFilter';
import CommissionInvoiceRequest from 'src/adminPanel/entities/offsetting/commissionInvoice/CommissionInvoiceRequest';
import { CommissionInvoiceRequestFilter } from 'src/adminPanel/entities/offsetting/commissionInvoice/CommissionInvoiceRequestFilter';
import { PageableQueryParams } from 'src/entities/basic-types/Pageable';
import callApi from '.';

// fetchCommissionInvoicesByFilter
export const getCommissionInvoicesByFilter = (
    pageable: PageableQueryParams = {},
    filter: CommissionInvoiceRequestFilter = new CommissionInvoiceRequestFilter('')
) => {
    let query = queryString.stringify({ ...pageable }, { skipEmpty: true, skipNull: true });
    if (query !== '') query = '?' + query;
    const endpoint = `/api/commissionInvoice/overview${query}`;
    return callApi(endpoint, { method: 'PUT', data: filter });
};

// fetchCommissionInvoicesByFilterId
export const getCommissionInvoicesByFilterId = (filterId: string, pageable: PageableQueryParams = {}) => {
    let query = queryString.stringify({ ...pageable }, { skipEmpty: true, skipNull: true });
    if (query !== '') query = '?' + query;
    const endpoint = `/api/commissionInvoice/overview/${filterId}${query}`;
    return callApi(endpoint);
};

// createNewCommissionInvoice
export const createNewCommissionInvoiceCall = (newCommissionInvoice: CommissionInvoiceRequest) => {
    const endpoint = `/api/commissionInvoice/add`;
    return callApi(endpoint, { method: 'POST', data: newCommissionInvoice });
};

// fetchCommissionInvoicePdf
export const getCommissionInvoicePdf = (commissionInvoiceId: string) => {
    const endpoint = `/api/commissionInvoice/${commissionInvoiceId}/invoicePdf`;
    return callApi(endpoint);
};

// fetchCommissionInvoiceDetailsPdf
export const getCommissionInvoiceDetailsPdf = (commissionInvoiceId: string) => {
    const endpoint = `/api/commissionInvoice/${commissionInvoiceId}/invoiceDetailsPdf`;
    return callApi(endpoint);
};

// fetchCommissionInvoiceFilter
export const getCommissionInvoiceFilters = () => {
    const endpoint = '/api/commissionInvoice/filter';
    return callApi(endpoint);
};

// createNewCommissionInvoiceFilter
export const createNewCommissionInvoiceFilterCall = (filter: CommissionInvoiceFilter) => {
    const endpoint = `/api/commissionInvoice/filter`;
    return callApi(endpoint, { method: 'POST', data: filter });
};

// updateCommissionInvoiceFilter
export const updateCommissionInvoiceFilterCall = (filter: CommissionInvoiceFilter) => {
    const endpoint = `/api/commissionInvoice/filter`;
    return callApi(endpoint, { method: 'PUT', data: filter });
};

// deleteCommissionInvoiceFilter
export const deleteCommissionInvoiceFilterCall = (filterId: string) => {
    const endpoint = `/api/commissionInvoice/filter/${filterId}`;
    return callApi(endpoint, { method: 'DELETE' });
};

// fetch CommissionInvoice Details
export const getCommissionInvoiceDetails = (commissionInvoiceId: string) => {
    const endpoint = `/api/commissionInvoice/${commissionInvoiceId}`;
    return callApi(endpoint);
};

// RZL-Export Commission Invoice
export const downloadCommissionInvoiceRzlExport = (startDate: string, endDate: string) => {
    const endpoint = '/api/commissionInvoice/exportRzl';
    return callApi(endpoint, { responseType: 'blob', params: { startDate, endDate } });
};

// RZL-Export Order
export const downloadOrderRzlExport = (startDate: string, endDate: string) => {
    const endpoint = '/api/orders/exportRzl';
    return callApi(endpoint, { responseType: 'blob', params: { startDate, endDate } });
};

// RZL-Export Adyen Batch
export const downloadAdyenBatchRzlExport = (firstBatch: string, lastBatch: string) => {
    const endpoint = '/api/batch/adyen/rzlExport';
    return callApi(endpoint, { responseType: 'blob', params: { firstBatch, lastBatch } });
};

// Create Commission Invoices
export const createCommissionInvoices = (commissionInvoiceDate: string) => {
    const endpoint = '/api/commissionInvoice/getAll';
    return callApi(endpoint, { method: 'POST', data: { invoiceDate: commissionInvoiceDate } });
};
